import { Preferences } from '@capacitor/preferences'

import { useIsNative } from './usePlatform'

const TOKEN_KEYS = {
  ACCESS_TOKEN: 'auth._token.refresh',
  REFRESH_TOKEN: 'auth._refresh_token.refresh',
}

export const useCapacitorAuth = () => {
  const isNative = useIsNative()

  const setTokens = async (accessToken: string, refreshToken: string) => {
    if (!isNative) return

    await Promise.all([
      Preferences.set({
        key: TOKEN_KEYS.ACCESS_TOKEN,
        value: accessToken,
      }),
      Preferences.set({
        key: TOKEN_KEYS.REFRESH_TOKEN,
        value: refreshToken,
      }),
    ])
  }

  const getTokens = async () => {
    if (!isNative) return null

    const [accessToken, refreshToken] = await Promise.all([
      Preferences.get({ key: TOKEN_KEYS.ACCESS_TOKEN }),
      Preferences.get({ key: TOKEN_KEYS.REFRESH_TOKEN }),
    ])

    return {
      accessToken: accessToken.value,
      refreshToken: refreshToken.value,
    }
  }

  const clearTokens = async () => {
    if (!isNative) return

    await Promise.all([
      Preferences.remove({ key: TOKEN_KEYS.ACCESS_TOKEN }),
      Preferences.remove({ key: TOKEN_KEYS.REFRESH_TOKEN }),
    ])
  }

  return {
    setTokens,
    getTokens,
    clearTokens,
  }
}
